import { denormalize } from 'normalizr';

import { ExperimentModel } from '../../../common/ExperimentModel';
import { Experiment } from '../../../lib/PlannerDTOs';
import { experiment as experimentSchema } from '../../../store/schema';
import { State } from '../../../store/state';
import {
  entitiesSelector,
  experimentEntitiesSelector,
} from '../../../store/state/entities/selectors';

export const experimentsViewSelector = (state: State) =>
  state.experiments!.view;

export const experimentsCollectionSelector = (
  state: State,
  experimentState: string,
) => experimentsViewSelector(state)[experimentState];

export const experimentsSelector = (
  state: State,
  experimentState: string,
): Experiment[] => {
  const entities = entitiesSelector(state);
  const experimentsCollection = experimentsCollectionSelector(
    state,
    experimentState,
  );
  const experiments = denormalize(
    experimentsCollection.items,
    [experimentSchema],
    entities,
  );
  return experiments;
};

export const experimentModelsSelector = (
  state: State,
  experimentState: string,
): ExperimentModel[] => {
  const experiments = experimentsSelector(state, experimentState);
  return experiments.map((experiment) => new ExperimentModel(experiment));
};

export const experimentSelector = (
  state: State,
  experimentName: string,
): Experiment | null => {
  const experimentEntities = experimentEntitiesSelector(state);
  return experimentEntities ? experimentEntities[experimentName] : null;
};
